if (!customElements.get('ss-quote-basket-label')) {
  customElements.define('ss-quote-basket-label', class extends HTMLElement {
    connectedCallback() {
      if (this.discovery) return;
      this.controller = new AbortController();
      const update = () => {
        const root = document.getElementById('quote-data');
        if (root && this.root !== root) {
          this.root = root;
          this.observer?.disconnect();
          this.observer = new MutationObserver(schedule);
          this.observer.observe(root, {subtree: true, childList: true, characterData: true});
        }
        const button = root?.querySelector('.view-quote-btn .omgrfq_view_quote_btn');
        this.nativeButton = button;
        const controls = document.querySelectorAll('[data-ss-quote-open]');
        const count = button?.textContent.match(/\(\s*(\d+)\s*\)\s*$/)?.[1];
        if (count !== undefined) this.count = count;
        const quantity = this.count || '0';
        const label = this.dataset.label + ' (' + quantity + ')';
        controls.forEach(control => {
          control.disabled = !button;
          if (control.getAttribute('aria-label') !== label) control.setAttribute('aria-label', label);
          const badge = control.querySelector('[data-ss-quote-count]');
          if (badge.textContent !== quantity) badge.textContent = quantity;
          badge.hidden = Number(quantity) === 0;
        });
        const ready = !!button && controls.length > 0;
        document.documentElement.toggleAttribute('data-ss-quote-header-ready', ready);
      };
      const schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; update(); });
      };
      document.addEventListener('click', event => {
        const control = event.target.closest('[data-ss-quote-open]');
        if (!control || control.disabled) return;
        event.preventDefault();
        this.nativeButton?.click();
      }, {signal: this.controller.signal});
      this.discovery = new MutationObserver(records => {
        if (document.getElementById('quote-data') !== this.root || records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-ss-quote-open]') || node.querySelector('[data-ss-quote-open]'))))) schedule();
      });
      this.discovery.observe(document.body, {childList: true, subtree: true});
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.discovery?.disconnect(); this.discovery = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      document.documentElement.removeAttribute('data-ss-quote-header-ready');
    }
  });
}
